import getGraphQlClient from '~graphql/getGraphQlClient';
import { onErrorShowMessage } from '~src/errors';
import {
  GET_CANVAS_BY_ID,
  FIND_PROJECT_TYPES,
  FIND_USER_CANVASES,
  COUNT_PROJECTS_BY_FORMAT,
} from '../queries/editorProjects';
import { unmarshalGraphqlResponse } from '~graphql/utils';

export const fetchEditorProjects = async ({ filters = {}, after = '' }) => {
  try {
    const graphQlClient = await getGraphQlClient();

    let where = {};
    if (filters.filterProjectType?.isGlobal) {
      where.editor_project_types_default_pointer = {
        have: { objectId: { equalTo: filters.filterProjectType.objectId } },
      };
    } else if (filters.filterProjectType?.objectId) {
      where.editor_project_types_pointer = {
        have: { objectId: { equalTo: filters.filterProjectType.objectId } },
      };
    }

    if (filters.filterFuneralService) {
      where.defunto_pointer = {
        have: { objectId: { equalTo: filters.filterFuneralService } },
      };
    }

    where.status = {
      equalTo: 'active',
    };

    const response = await graphQlClient.query({
      variables: { limit: 24, where, after },
      query: FIND_USER_CANVASES,
    });

    return unmarshalGraphqlResponse(response.data, 'findEditorCanvas');
  } catch (error) {
    onErrorShowMessage();
    console.error(error);
  }
};

export const fetchEditorProjectById = async (id) => {
  try {
    const graphQlClient = await getGraphQlClient();

    const response = await graphQlClient.query({
      variables: {
        id,
      },
      query: GET_CANVAS_BY_ID,
    });

    return unmarshalGraphqlResponse(response.data, 'getEditorCanvas');
  } catch (error) {
    onErrorShowMessage();
    console.error(error);
  }
};

export const fetchEditorProjectTypes = async () => {
  try {
    const graphQlClient = await getGraphQlClient();

    const response = await graphQlClient.query({
      variables: {},
      query: FIND_PROJECT_TYPES,
    });

    const typesDefault = unmarshalGraphqlResponse(
      response.data,
      'findEditorProjectTypesDefault'
    );
    const types = unmarshalGraphqlResponse(
      response.data,
      'findEditorProjectTypes'
    );

    return [...typesDefault.edges, ...types.edges];
  } catch (error) {
    onErrorShowMessage();
    console.error(error);
  }
};

export const fetchCountEditorProjectsByFormat = async (formatId) => {
  try {
    const graphQlClient = await getGraphQlClient();

    const response = await graphQlClient.query({
      fetchPolicy: 'network-only',
      variables: { formatId },
      query: COUNT_PROJECTS_BY_FORMAT,
    });

    return unmarshalGraphqlResponse(response.data, 'findEditorCanvas');
  } catch (error) {
    onErrorShowMessage();
    console.error(error);
  }
};
